import { Component } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { MCommonListModalRequest } from 'src/app/utils/utils.service';
import { WsShopallService } from 'src/app/ws/wsShopAll/ws-shopall.service';
import { MBrandListModal, MGetBrandResponse } from '../product/product.module';
import { NavigationExtras, Router } from '@angular/router';

@Component({
  selector: 'app-brands-directory',
  templateUrl: './brands-directory.component.html',
  styleUrls: ['./brands-directory.component.scss']
})
export class BrandsDirectoryComponent {
  alphabet = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
  mCommonListModalRequest: MCommonListModalRequest = new MCommonListModalRequest()
  mGetBrandResponse: MGetBrandResponse = new MGetBrandResponse()
  alphaSelected: boolean = false;
  alphaSelectedValue: any = '';
  alphabets: any = [];

  constructor(private wsShopAllService: WsShopallService, private router: Router) {
  }

  ngOnInit() {
    this.getAllBrand()
  }

  /**
   * Date: 10-06-23
   * Method : This method is used to get all brand 
   */
  async getAllBrand() {
    this.mCommonListModalRequest.take = 1000
    this.mCommonListModalRequest.isAllowInactive = false;
    const getAllBrand = this.wsShopAllService.getAllBrand(this.mCommonListModalRequest)
    await lastValueFrom(getAllBrand).then(async response => {
      if (response && response.statusCode == 200) {
        this.mGetBrandResponse.data = response.data.sort(function (a: any, b: any) {
          if (a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase()) {
            return -1;
          } else {
            return 0
          }
        });
        this.mGetBrandResponse.data.forEach((brand: any) => {
          this.alphabet.forEach(alpha => {
            let brandname = brand.name.toLowerCase();
            let alphaSmall = alpha.toLowerCase()
            if (brandname.startsWith(alphaSmall)) {
              if (this.alphabets.length < 1) {
                this.alphabets.push(alpha);
              } else {
                if (this.alphabets.indexOf(alpha) == -1) {
                  this.alphabets = [...this.alphabets, ...alpha]
                }
              }
            }
          })
        })
      } else {
      }
    })
  }

  selectAlphabet(val: any) {
    if (this.alphaSelectedValue == val || val == 'all') {
      this.alphaSelected = false
      this.alphaSelectedValue = '';
    } else {
      this.alphaSelectedValue = val;
      this.getAllBrand();
      this.alphaSelected = true
    }
  }

  viewBrandDetail(brand: MBrandListModal) {
    const navigationExtras: NavigationExtras = {
      state: {
        name: brand.name
      },
    };
    this.router.navigate(["/individual-brand/" + brand.name.replace(/[&\/\#,+()$~%.'":*?<>{}]/g, '_')], { state: navigationExtras })
  }

  brandAvailable(alpha: any) {
    const valid = this.mGetBrandResponse.data && this.mGetBrandResponse.data.length > 0 && this.mGetBrandResponse.data.some((brand: any) => brand.name.startsWith(alpha.toUpperCase()) || brand.name.startsWith(alpha.toLowerCase()));
    return valid;
  }
}

